/**
 * Extend the action.js of Ajax Cart Pro module to trigger `ajax:addToCart` event so that Google
 * Analytics can track this event.
 */
define([
    'jquery'
], function($) {
    "use strict";

    return function (widget) {
        $.widget('awacp.action', widget, {
            _fire: function(actionId, url, data) {
                data.push({
                    name: this.options.requestParamName,
                    value: 1
                });
                const param = $.param(data);
                $.ajax({
                    url: url,
                    data: param,
                    type: 'post',
                    dataType: 'json',
                    error: () => {
                        this.closeUi();
                    },
                    success: (response, status) => {
                        if (status === 'success') {
                            const formObj = data.find(obj => obj.name === 'form');
                            const form = formObj ? formObj.value : null;
                            if (form && url && url.indexOf('checkout/cart/add/') > 0) {
                                const productIds = this._idResolver(form);
                                const productInfo = this._infoResolver(form);
                                $(document).trigger('ajax:addToCart', {
                                    'sku': form.data().productSku,
                                    'productIds': productIds,
                                    'productInfo': productInfo,
                                    'form': form,
                                    'response': response
                                });
                            }
                            if (!this.options.displayConfirmation && response.addSuccess) {
                                $(this.options.uiSelector).trigger('awacpAction:close');
                                this.closeUi();
                                return;
                            }
                            if (response.reloadUrl) {
                                $(location).attr('href', response.reloadUrl);
                                $(this.options.uiSelector).trigger('awacpAction:close');
                                this.closeUi();
                            }
                            if (response.backUrl) {
                                this._fire(actionId, response.backUrl, data);
                            }
                            let haveBlocksBeenUpdated = false;
                            if (response.ui) {
                                this.updateUi(response.ui);
                                haveBlocksBeenUpdated = true;
                            }
                            if (response.related) {
                                this.updateRelated(response.related);
                                haveBlocksBeenUpdated = true;
                            }
                            if (haveBlocksBeenUpdated) {
                                const wasThereAnyUiWithTheResponse = ((response || {}).ui || "").trim().length > 0;
                                const wasExplictlyASuccess = !!(response || {}).addSuccess || false;
                                const shouldTheUiPresent_isThisConsideredAnAddSuccess = wasThereAnyUiWithTheResponse || wasExplictlyASuccess;
                                this.updateBlocks(actionId, shouldTheUiPresent_isThisConsideredAnAddSuccess);
                            }
                        } else {
                            this.closeUi();
                        }
                    }
                });
            },

            /**
             * Returns id's of products in form.
             *
             * @param {jQuery} $form
             * @return {Array}
             */
            _idResolver: function ($form) {
                const productIds = [];
                const $qtyFields = $form.find('.qty:input');

                $qtyFields.each((index, item) => {
                    if ($(item).val() > 0) {
                        productIds.push($(item).data('product-id').toString());                        
                    }
                });
                return productIds;
            },

            /**
             * Returns info's of products in form.
             *
             * @param {jQuery} $form
             * @return {Array}
             */
            _infoResolver: function ($form) {
                const productInfo = [];
                const $qtyFields = $form.find('.qty:input');

                $qtyFields.each((index, item) => {
                    if ($(item).val() > 0) {
                        productInfo.push({id:$(item).data('product-id').toString()});
                    }
                });
                return productInfo;
            },

            closeUi: function () {
            }
        });

        return $.awacp.action;
    }
});
